import { Box, Button, Modal, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useStyles } from './styles'

interface IRemoveCertificateModal {
  openModal: boolean
  setOpenModal: () => void
  removeCertificate: () => void
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 520,
  Height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  overflow: 'hidden',
  padding: '1.5rem',
}

const RemoveCertificateModal = ({ openModal, setOpenModal, removeCertificate }: IRemoveCertificateModal) => {
  const [fieldValue, setFieldValue] = useState<string>('')

  const classes = useStyles()

  return (
    <Modal
      open={openModal}
      onClose={setOpenModal}
    >
      <Box sx={style}>
        <Typography className={classes.title}>Remover autenticação</Typography>

        <Box className={classes.descriptionBox}>
          <Typography className={classes.description}>
            Deseja remover a autenticação? Esta ação impede a sincronização do eSocial com o cofre digital, tornando
            impossível a utilização de múltiplas funcionalidades
          </Typography>

          <Box className={classes.textfieldContainer}>
            <Typography className={classes.description}>
              Para confirmar a remoção do certificado, digite <strong>Remover</strong> no campo abaixo
            </Typography>

            <TextField
              variant='outlined'
              placeholder='Remover'
              className={classes.textfield}
              onChange={(event) => setFieldValue(event.target.value)}
            />
          </Box>

          <Box className={classes.buttonContainer}>
            <Button
              variant='text'
              color='primary'
              onClick={setOpenModal}
            >
              Continuar com a autenticação
            </Button>
            <Button
              variant='contained'
              sx={{
                backgroundColor: 'red',
              }}
              className={classes.buttonRemoval}
              disabled={fieldValue !== 'Remover' || fieldValue.length === 0}
              onClick={() => {
                removeCertificate()
                setOpenModal()
              }}
            >
              Remover
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default RemoveCertificateModal
